import React from "react";

const AgethIcon: React.FC = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.854 3.79483L14.9411 2.04826C15.1865 1.90942 15.4905 2.08671 15.4905 2.36866V2.44401C15.4905 2.83399 15.6759 3.20075 15.9898 3.43202L19 5.64915C20.0337 6.41047 19.9425 7.98335 18.8278 8.6201L15.9521 10.2629C15.2551 10.6611 15.1984 11.6447 15.845 12.1202L18.9948 14.4367C20.03 15.1981 19.9385 16.773 18.822 17.4093L15.7188 19.1781C15.4734 19.3179 15.1684 19.1407 15.1684 18.8582V18.7664C15.1684 18.3784 14.9849 18.0132 14.6735 17.7817L11.6726 15.5503C10.6429 14.7846 10.7406 13.2131 11.8571 12.5808L14.7013 10.9701C15.3984 10.5753 15.4603 9.5945 14.8183 9.11535L11.6663 6.76273C10.6389 5.99586 10.7382 4.42614 11.854 3.79483Z"
      fill="black"
    />
    <path
      d="M5.08488 6.56794L8.17193 4.82138C8.41733 4.68254 8.72133 4.85983 8.72133 5.14178V5.21713C8.72133 5.60711 8.9067 5.97386 9.2207 6.20514L12.2308 8.42225C13.2644 9.1836 13.1732 10.7565 12.0586 11.3933L9.18291 13.036C8.48594 13.4342 8.42926 14.4178 9.07589 14.8933L12.2256 17.2098C13.2608 17.9712 13.1693 19.5461 12.0529 20.1824L8.94964 21.9512C8.70423 22.0911 8.39922 21.9138 8.39922 21.6314V21.5395C8.39922 21.1515 8.2157 20.7863 7.90434 20.5548L4.90345 18.3234C3.87378 17.5577 3.97142 15.9862 5.08794 15.3539L7.93219 13.7432C8.62927 13.3484 8.69109 12.3676 8.04911 11.8885L4.89717 9.53586C3.86974 8.769 3.96902 7.19925 5.08488 6.56794Z"
      fill="black"
    />
  </svg>
);

export default AgethIcon;
